import { delay } from '@xylabs/sdk-js'

import { AddressDetailsData, AddressInfoData } from '../models'
import { AddressDetailsWrapper } from './AddressDetailsWrapper'
import { InfoWrapper } from './InfoWrapper'

export class AddressInfoWrapper extends InfoWrapper<AddressInfoData> {
  constructor(data?: AddressInfoData) {
    super('addressInfo', data, true)
  }

  public getSanitizedData() {
    return this.data
  }

  public getBilling() {
    if (this.data.billing) {
      return new AddressDetailsWrapper(this.data.billing, 'Billing')
    }
  }

  public getBillingData() {
    return this.data.billing
  }

  public setBilling(address: AddressDetailsData) {
    this.data.billing = address
    this.save()
    return this
  }

  public getShipping() {
    if (this.data.shipping) {
      return new AddressDetailsWrapper(this.data.shipping, 'Shipping')
    }
  }

  public getShippingData() {
    return this.data.shipping
  }

  public setShipping(address: AddressDetailsData) {
    this.data.shipping = address
    this.save()
    return this
  }

  public getSameAddress() {
    return this.data.sameAddress ?? true
  }

  public setSameAddress(value: boolean) {
    this.data.sameAddress = value
    if (value) {
      this.data.shipping = undefined
    }
    this.save()
    return this
  }

  public async errors() {
    await delay(0)
    let result = this.getBilling()?.errors() ?? [Error('Billing address missing')]
    if (!this.getSameAddress()) {
      result = result.concat(this.getShipping()?.errors() ?? [Error('Shipping address missing')])
    }
    return result
  }
}
